(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    function initSlideshow(el) {
      const slides = Array.from(el.querySelectorAll('.mega-menu-slideshow__slide'));
      if (slides.length < 2) {
        if (slides.length === 1) slides[0].classList.add('is-active');
        return;
      }

      let current = 0;
      let timer = null;

      // Build dots
      const dotsEl = document.createElement('div');
      dotsEl.className = 'mega-menu-slideshow__dots';
      slides.forEach((_, i) => {
        const dot = document.createElement('span');
        dot.className = 'mega-menu-slideshow__dot' + (i === 0 ? ' is-active' : '');
        dot.addEventListener('click', () => goTo(i));
        dotsEl.appendChild(dot);
      });
      el.appendChild(dotsEl);

      function goTo(index) {
        slides[current].classList.remove('is-active');
        dotsEl.children[current].classList.remove('is-active');
        current = (index + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        dotsEl.children[current].classList.add('is-active');
      }

      slides[0].classList.add('is-active');

      function start() { timer = setInterval(() => goTo(current + 1), 2800); }
      function stop() { clearInterval(timer); }

      el.addEventListener('mouseenter', stop);
      el.addEventListener('mouseleave', start);
      start();
    }

    function initAll() {
      document.querySelectorAll('[data-menu-slideshow]').forEach(initSlideshow);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
